export default __webpack_public_path__ + "static/media/manage_prospects.afb57fff.png";